function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  ",
        "\n\n  &.--is-link {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { borderRadius, height } from 'styled-system';
import { Image } from '@dutchie/common/components/rebass-compat';
import styled from 'styled-components';
export default styled(Image)(_templateObject(), borderRadius, height);
